
export default function config() {
  // // 客户信息
  // const m_customerInfo = [
  //   {
  //     el: 'text',
  //     itemConfig: {
  //       label: '客户名称',
  //       prop: 'customerName'
  //     }
  //   },
  //   {
  //     el: 'text',
  //     itemConfig: {
  //       label: '客户类型',
  //       prop: 'rentCalculationRules',
  //       value: '企业客户'
  //     }
  //   },
  //   {
  //     el: 'select',
  //     itemConfig: {
  //       label: '选择租赁方案',
  //       prop: 'planId'
  //     },
  //     elConfig: {
  //       options: {
  //         label: 'name',
  //         value: 'id',
  //         list: []
  //       },
  //       events: {
  //         change: this.planChange
  //       }
  //     }
  //   },
  //   {
  //     el: 'text',
  //     itemConfig: {
  //       label: '上架单ID',
  //       prop: 'planRecordId'
  //     }
  //   }
  // ]
  const m_customerInfoModel = {}

  // 车辆选择
  const m_addVehicle = [
    {
      el: 'select',
      itemConfig: {
        label: '是否备车',
        prop: 'readyLeaseState',
      },
      elConfig: {
        options: {
          label: 'readyLeaseState',
          value: 'id',
          list: [{
            id: '',
            readyLeaseState: '全部',
          },
          {
            id: 1,
            readyLeaseState: '已备车',
          },
          // {
          //   id: 0,
          //   readyLeaseState: '未备车'
          // }
          ],
        },
        events: {
          change: (e) => {
            this.$refs.components.$refs.AddVehicle.plateNoRemoteMethod(e)
          },
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '添加车辆',
        prop: 'plateNo',
      },
      elConfig: {
        clearable: true,
        filterable: true,
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
      },
    },
  ]
  const m_addVehicleModel = {
    carInfoList: [],
  }
  return {
    boundVehicleList: {
      // 车辆选择
      m_addVehicle,
      // m_customerInfo
    },
    boundVehicleModel: {
      m_customerInfoModel,
      m_addVehicleModel,
    },
  }
}
